import React, { useContext } from 'react';
import { GameContext } from '../contexts/GameContext';
import { GAME_STATE } from '../utils/constants';

const GameBanner = () => {
  const { 
    gameState, 
    winner, 
    stageInfo, 
    rewardInfo,
    loadNextStage,
    initializeGame,
    notification
  } = useContext(GameContext);
  
  // Show notification
  if (notification) {
    return (
      <div className="fixed top-4 right-4 bg-black bg-opacity-80 text-white px-4 py-3 rounded-lg shadow-lg z-50 max-w-md">
        {notification}
      </div>
    );
  }

  // Return victory/defeat banner
  if (gameState === GAME_STATE.GAME_OVER) {
    const isVictory = winner === 'red';
    
    return (
      <div 
        className="absolute bg-black bg-opacity-80 py-8 w-full text-center"
        style={{ top: '40%', transform: 'translateY(-50%)' }}
      >
        <h2 className={`text-4xl font-bold mb-2 ${isVictory ? 'text-green-500' : 'text-red-500'}`}>
          {isVictory ? 'VICTORY!' : 'DEFEAT!'}
        </h2>
        <p className="text-white text-xl px-4 mb-2">
          {isVictory 
            ? 'You successfully defeated the enemy forces!' 
            : 'Your forces were overrun by the enemy!'}
        </p>
        
        {/* Show rewards on victory */}
        {isVictory && rewardInfo && (
          <div className="bg-green-800 bg-opacity-70 mx-auto max-w-md p-2 rounded-lg mb-4">
            <h3 className="text-white font-bold">Battle Rewards:</h3>
            <div className="grid grid-cols-2 gap-x-2 text-white">
              <div className="text-right">Base Reward:</div>
              <div className="text-left font-bold">{rewardInfo.baseReward} 💰</div>
              
              <div className="text-right">Performance Bonus:</div>
              <div className="text-left font-bold">{rewardInfo.performanceBonus} 💰</div>
              
              <div className="text-right">Stage Bonus:</div>
              <div className="text-left font-bold">{rewardInfo.stageBonus} 💰</div>
              
              <div className="text-right border-t border-white pt-1 mt-1">Total:</div>
              <div className="text-left font-bold border-t border-white pt-1 mt-1">{rewardInfo.totalReward} 💰</div>
            </div>
          </div>
        )}
        
        <div className="flex justify-center gap-3 mt-4">
          {isVictory ? (
            <button
              onClick={loadNextStage}
              className="bg-green-600 text-white px-6 py-3 rounded-lg font-bold text-lg shadow-lg hover:bg-green-700 active:transform active:scale-95 transition-all"
            >
              Continue to Next Stage
            </button>
          ) : (
            <button
              onClick={initializeGame}
              className="bg-red-600 text-white px-6 py-3 rounded-lg font-bold text-lg shadow-lg hover:bg-red-700 active:transform active:scale-95 transition-all"
            >
              New Game
            </button>
          )}
        </div>
      </div>
    );
  }
  
  // Return level information during placement phase
  if (gameState === GAME_STATE.PLACEMENT && stageInfo) {
    return (
      <div 
        className="absolute top-4 left-4 bg-blue-500 bg-opacity-70 px-4 py-2 text-white rounded max-w-sm"
      >
        <h3 className="font-bold text-base">{stageInfo.stageName}</h3>
        <p className="text-sm">{stageInfo.stageDescription}</p>
      </div>
    );
  }
  
  // Return battle status during battle phase
  if (gameState === GAME_STATE.BATTLE) {
    return (
      <div 
        className="absolute top-4 right-4 bg-yellow-600 bg-opacity-70 px-4 py-2 text-white rounded"
      >
        <p className="font-bold text-base">Battle in Progress</p>
        <p className="text-sm">Units are fighting automatically</p>
      </div>
    );
  }
  
  return null;
};

export default GameBanner;